import moment from 'moment-timezone';

const setMomentTimezone = (tz) => {
  moment.tz.setDefault(tz);
};

export default setMomentTimezone;
